module.exports = __webpack_public_path__ + "static/media/outline_Default_Right.d20b9c51.svg";